export var SHADOW_FILTER_ID = 'block-shadow';
export var DEFAULT_MARGINS = { top: 30, right: 10, bottom: 5, left: 10 };
export var SEPARATOR = '|';
export var MINIMAL_BLOCK_SIZE_IN_PIXELS = 10;
